import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { cardOnFile } from 'services/cardOnFile/cardOnFile';
import type {
  ChargeRequestBody,
  ChargeResponse,
} from 'services/cardOnFile/models';

export type ChargeError = 'failed' | 'balance' | 'declined';
type ChargeErrorResponse = Error & {
  status?: number;
  parsedBody: {
    status: ChargeError;
  };
};

const useCharge = (): UseMutationResult<
  ChargeResponse,
  ChargeErrorResponse,
  ChargeRequestBody
> =>
  useMutation<ChargeResponse, ChargeErrorResponse, ChargeRequestBody>({
    mutationKey: ['cardOnFileCharge'],
    mutationFn: attrs => cardOnFile.charge(attrs),
  });

export { useCharge };
